import { createSlice } from "@reduxjs/toolkit";
import { gatewayApi } from "./gatewayApi";
const initialState = {
  gataways: null,
  gateway: null,
  metaCount: null,
  messages: null,
  twinId: null,
  messagesMeta: null,
  readedMessages: null,
  readedMessagesCount: null,
  instanceId: null,
  walkthroughs: null,
};

const gatewaySlice = createSlice({
  name: "gatewaySlice",
  initialState,
  reducers: {
    cleanGatewayData(state) {
      state.twinId = null;
    },
    unsetGatewayShow(state) {
      state.gateway = null;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      gatewayApi.endpoints.getIndexGateway.matchFulfilled,
      (state, action) => {
        state.gataways = action.payload.data;
        state.metaCount = action.payload.meta.count;
      }
    );
    builder.addMatcher(
      gatewayApi.endpoints.getShowGateway.matchFulfilled,

      (state, action) => {
        state.gateway = action.payload.data.attributes;
        state.twinId = action.payload.data.attributes.digital_twin_id;
        state.instanceId = action.payload.data.id;
      }
    );
    builder.addMatcher(
      gatewayApi.endpoints.getGatewayMessages.matchFulfilled,
      (state, action) => {
        state.messages = action.payload.data;
        state.messagesMeta = action.payload.meta.count;
      }
    );
    builder.addMatcher(
      gatewayApi.endpoints.getMeterReadedMessages.matchFulfilled,
      (state, action) => {
        state.readedMessages = action.payload.data;
        state.readedMessagesCount = action.payload.meta.count;
      }
    );
    builder.addMatcher(
      gatewayApi.endpoints.getWalkthrough.matchFulfilled,
      (state, action) => {
        state.walkthroughs = action.payload.data.attributes.data;
      }
    );
  },
});
export const gatewayActions = gatewaySlice.actions;
export default gatewaySlice.reducer;
